import { pick } from './pick';

export const commutePick = <T extends object>(values: T, dataList: { id: number }[]) =>
  pick(
    values,
    dataList.map(({ id }) => id),
  ) as T;
